export default "<app-settings-top></app-settings-top>\n"